<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import PillSelect from '@/modules/shared/components/pill-select.vue'
import { useCandidateStore } from '@/modules/connecting/stores/candidate-store'
import { useWorkspaceOnboardingStore } from '../../stores/workspace-onboarding-store'

const candidateStore = useCandidateStore()
const onboardingStore = useWorkspaceOnboardingStore()

const INVESTMENT_STAGES = ['Pre-Seed', 'Seed', 'Early', 'Growth', 'Pre-IPO', 'Secondaries']

const form = ref({ investment_stage: [] as string[] })

const candidate = computed(() => {
  const id = onboardingStore.workspace?.connecting_candidate_id
  return id ? candidateStore.getCandidate(id.toString()) : undefined
})

watch(
  candidate,
  (c) => {
    if (!c) return
    form.value.investment_stage = Array.isArray(c.investment_stage) ? c.investment_stage : []
  },
  { immediate: true },
)

const submit = async (): Promise<boolean> => {
  const candidateId = onboardingStore.workspace?.connecting_candidate_id
  if (!candidateId) return false

  await candidateStore.updateCandidate({
    id: candidateId,
    subject_id: onboardingStore.workspace!.id,
    subject_type: 'Group',
    investment_stage: form.value.investment_stage,
  })
  return true
}

defineExpose({ submit })
</script>

<template>
  <div class="flex flex-1 flex-col">
    <PillSelect v-model="form.investment_stage" :options="INVESTMENT_STAGES" />
  </div>
</template>
